// extracted by mini-css-extract-plugin
module.exports = {"message":"style_message__-QIXG","admins":"style_admins__2M3HR","slackImage":"style_slackImage__oB+-M"};